import React from 'react';
interface CTAButtonProps {
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  onClick,
  className = ''
}: CTAButtonProps) {
  return;
}